export const footerData = {
  footerCotizacion: {
    tituloPrincipal: "<span>REQUEST A</span> QUOTE",
    footerCotizacionData: [
      { formText: "NAME" },
      { formText: "EMAIL" },
      { formText: "PHONE" },
      { formText: "SERVICE TYPE" },
      { formText: "ADDRESS / CITY" },
      { formText: "MESSAGE" }
    ],
    botonTexto: "SEND"
  },
  footerInformation: {
    titulo: "INFORMATION",
    links: [
      {
        title: "FAQ’s",
        url: "#"
      },
      {
        title: "TERMS AND CONDITIONS",
        url: "#"
      },
      {
        title: "PRIVACY NOTICE",
        url: "#"
      },
      {
        title: "CAREERS",
        url: "#"
      }
    ]
  },
  footerContacto: {
    titulo: "CONTACT US!",
    footerContactoData: [
      {
        titulo: "West 12th Avenue, Vancouver, British Columbia, Canada, V5Y 1V4",
      },
      {
        titulo: "(236) 997-6291",
      },
      {
        titulo: "highsolutionsvancouver@gmail.com",
      }
    ],
    tituloRedesSociales: "FOLLOW US",
    redesSociales: [
      {
        plataforma: "facebook",
        link: "https://www.facebook.com/QualitySeal_com_mx",
        icono: "FaFacebookF"
      },
      {
        plataforma: "instagram",
        link: "https://www.instagram.com/QualitySeal_com_mx",
        icono: "FaInstagram"
      },
      {
        plataforma: "youtube",
        link: "https://www.youtube.com/@QualitySeal_com_mx",
        icono: "FaYoutube"
      },
      {
        plataforma: "tiktok",
        link: "https://www.tiktok.com/@QualitySeal_com_mx",
        icono: "FaTiktok"
      }
    ]
  },
  footerVisitanosComponent: {
    titulo: "VISIT US"
  },
  alertas: {
    alertaSuccess: {
      titulo: "Success!",
      texto: "Your request has been sent successfully.",
      colorBoton: "#28a745",
      textoBoton: "OK"
    },
    alertaError: {
      titulo: "Error",
      texto: "There was a problem sending your request.",
      colorBoton: "#dc3545",
      textoBoton: "Close"
    }
  },
  footerCopy: {
    textoCopy: "Copyright © {{year}} HRD Painting & Restoration | All Rights Reserved"
  }
};
